export const consentStorageKey = 'palmate-cookie-consent';
export const legacyConsentStorageKey = 'palmate-analytics-consent';

export function normalizeConsent(value) {
  // The previous boolean API authorizes analytics only.
  return {
    analytics: value === true || value?.analytics === true,
    marketing: value?.marketing === true,
  };
}

export function readConsent(storage) {
  try {
    const saved = storage.getItem(consentStorageKey);
    if (saved !== null) {
      const value = JSON.parse(saved);
      if (value?.version === 1 && typeof value.analytics === 'boolean' && typeof value.marketing === 'boolean') {
        return normalizeConsent(value);
      }
      return null;
    }
    const legacy = storage.getItem(legacyConsentStorageKey);
    if (legacy === 'granted' || legacy === 'denied') return normalizeConsent(legacy === 'granted');
  } catch {}
  return null;
}

export function saveConsent(storage, value) {
  const consent = normalizeConsent(value);
  try { storage.setItem(consentStorageKey, JSON.stringify({ version: 1, ...consent })); } catch {}
  // Keep the analytics-only value compatible with a rollback to the old banner.
  try { storage.setItem(legacyConsentStorageKey, consent.analytics ? 'granted' : 'denied'); } catch {}
}
